import { api } from '../../api-helper';
import { URLS } from '../../../constants/URLS';

export const getRecordingJuisdictions = (searchQuery, page, limit = 5) => {
  return api.get(URLS.recordingJuisdictions, {
    params: {
      ...(searchQuery && { query: searchQuery }),
      ...(page && { page: page }),
      limit: limit
    },
    headers: {
      needsToken: true
    }
  });
};

export const getRecordingJuisdictionByID = (recordingID) => {
  return api.get(URLS.recordingJurisdiction, {
    params: {
      id: recordingID
    },
    headers: {
      needsToken: true
    }
  });
};

export const createRecordingJuisdiction = (recordingData) => {
  return api.post(URLS.recordingJurisdiction, recordingData, {
    headers: {
      needsToken: true
    }
  });
};

export const updateRecordingJuisdiction = (recordingData) => {
  return api.put(URLS.recordingJurisdiction, recordingData, {
    headers: {
      needsToken: true
    }
  });
};

export const deleteRecordingJuisdiction = (recordingID) => {
  return api.delete(URLS.recordingJurisdiction, {
    params: {
      id: recordingID
    },
    headers: {
      needsToken: true
    }
  });
};

export const getOrderSearchSectionById = (orderID) => {
  return api.get(`${URLS.orderSearchSection}?id=${orderID}`, {
    headers: {
      needsToken: true
    }
  });
};
